import React, { useContext } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import {
  Home,
  SignIn,
  SignUp,
  ForgotPassword,
  Profile,
  Muncipalities,
  ChangePassword,
  Transactions,
  EmailVerify,
  MuncipalityCreation,
  MunicipalityDetails,
  TransactionDetails,
  TransactionForm,
  ProcessAccount,
  Users,
} from '@app/modules';
import { PrivateRoute } from './private-route';
import { Layout } from '@app/components/layout';
import { AuthContext } from '@app/providers';
import UserRoles from '@app/modules/user-roles';
import {
  municipalityPermission,
  showTransactionPage,
  usersPermissions,
} from '@app/utils/permissions';
import ErrorPage from '@app/components/error-pages';
import { DocumentsList } from '@app/modules/documents';
import { QrTransactionDetails } from '@app/modules/qr-code';

export default function Routes() {
  const { userInfo }: any = useContext(AuthContext);
  const routes = [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/sign-in',
      component: SignIn,
    },
    {
      path: '/sign-up',
      component: SignUp,
    },
    {
      path: '/process-account/:firebaseId',
      component: ProcessAccount,
    },
    {
      path: '/email-verify',
      component: EmailVerify,
    },
    {
      path: '/forgot-password',
      component: ForgotPassword,
    },
    {
      path: '/profile',
      component: Profile,
      private: true,
    },
    {
      path: '/change-password',
      component: ChangePassword,
      private: true,
    },
    {
      path: '/transaction-details/:transactionId',
      component: QrTransactionDetails,
    },
  ];

  const transactionRoutes = [
    {
      path: '/transactions',
      component: showTransactionPage(userInfo) ? Transactions : ErrorPage,
      private: true,
    },
    {
      path: '/transactions/approved',
      component: Transactions,
      private: true,
    },
    {
      path: '/transactions/documents',
      component: DocumentsList,
      private: true,
    },
    {
      path: '/transactions/search/:searchText',
      component: Transactions,
      private: true,
    },
    {
      path: '/transactions/approved/search/:searchText',
      component: Transactions,
      private: true,
    },
    {
      path: '/transactions/details/:transactionId',
      component: TransactionDetails,
      private: true,
    },
    {
      path: '/transactions/edit/:transactionId',
      component: TransactionForm,
      private: true,
    },
    {
      path: '/transactions/create',
      component: TransactionForm,
      private: true,
    },
  ];

  const superAdminUserRoutes = [
    {
      path: '/municipalities',
      component: municipalityPermission(userInfo) ? Muncipalities : ErrorPage,
      private: true,
    },
    {
      path: '/municipalities/create',
      component: MuncipalityCreation,
      private: true,
    },
    {
      path: '/municipalities/details/:municipalityId',
      component: MunicipalityDetails,
      private: true,
    },
    {
      path: '/municipalities/edit/:municipalityId',
      component: MuncipalityCreation,
      private: true,
    },
    {
      path: '/users',
      component: usersPermissions(userInfo) ? Users : ErrorPage,
      private: true,
    },
    {
      path: '/user-roles',
      component: usersPermissions(userInfo) ? UserRoles : ErrorPage,
      private: true,
    },
  ];

  let allRoutes = [...routes];
  allRoutes = allRoutes.concat(transactionRoutes).concat(superAdminUserRoutes);

  return (
    <Router>
      <Layout />
      <Switch>
        {allRoutes.map((route, i) =>
          route.private ? (
            <PrivateRoute exact path={route.path} key={i}>
              <route.component />
            </PrivateRoute>
          ) : (
            <Route exact path={route.path} key={i}>
              <route.component />
            </Route>
          ),
        )}
        <Route>
          <div>Invalid Page</div>
        </Route>
      </Switch>
    </Router>
  );
}
